export default __webpack_public_path__ + "static/media/yellow_circle_checkmark.38c1a98e.svg";